import './App.css';
import Home from './components/pages/Home/Home';

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
